import { render } from "./GestioneCredito.vue?vue&type=template&id=57658357&scoped=true"
import script from "./GestioneCredito.vue?vue&type=script&lang=js"
export * from "./GestioneCredito.vue?vue&type=script&lang=js"

import "./GestioneCredito.vue?vue&type=style&index=0&id=57658357&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57658357"]])

export default __exports__